// Pure label helpers for the merged thinking/steps card
// (frontend/src/components/ChatInterface/MessageBubble.jsx). No React
// import — kept in a sibling module, same pattern as imageTokens.js in this
// directory, so `npm test` can exercise the label logic without a JSX parse.

function isResearchStep(step) {
  return step?.tool === 'query_research_findings';
}

// One step's line of text. `past: true` drops the "-ing" in-flight framing
// for the collapsed strip's expanded list; callers add their own trailing
// ellipsis on the current/last live line — this helper never appends one.
export function stepLineText(step, { past = false } = {}) {
  const verb = past
    ? (isResearchStep(step) ? 'Checked saved research' : 'Searched the web')
    : (isResearchStep(step) ? 'Checking saved research' : 'Searching the web');
  const query = step?.query;
  const suffix = query && query.length > 1 ? ` — “${query}”` : '';
  return `${verb}${suffix}`;
}

// Collapsed-strip summary once the answer has content. null when there is
// nothing to summarize — callers render no strip in that case.
export function summarizeSteps(steps) {
  if (!Array.isArray(steps) || steps.length === 0) return null;
  const n = steps.length;
  const allResearch = steps.every(isResearchStep);
  const allWeb = steps.every((s) => !isResearchStep(s));
  const verb = allResearch ? 'Checked saved research' : allWeb ? 'Searched the web' : 'Searched';
  return `${verb} · ${n} step${n === 1 ? '' : 's'}`;
}
